import React from "react";
import { Box } from "@mui/material";

// ─────────────────────────────────────────────────────────────────────────────
// Logo — the brand mark, in one place.
//
// There are two wordmark files, not one, and the choice is not cosmetic. The
// logo is a single flat colour rather than a shape carrying its own contrast:
// the navy version is invisible on the dark dashboard (#080A0F) and the cream
// version is invisible on the white auth pages (#ffffff). So `on` names the
// SURFACE the logo sits on, and the component picks the file that shows up
// against it.
//
// PUBLIC_URL rather than a bare "/" path: CRA rewrites it at build time, so
// this keeps working if the app is ever served from a sub-path.
// ─────────────────────────────────────────────────────────────────────────────

const base = process.env.PUBLIC_URL || "";

export function Wordmark({ on = "dark", height = 34, sx = {}, ...rest }) {
  const src = on === "dark"
    ? `${base}/fennira-wordmark-light.png`   // cream artwork for dark surfaces
    : `${base}/fennira-wordmark-dark.png`;   // navy artwork for light surfaces

  return (
    <Box
      component="img"
      src={src}
      alt="Fennira"
      sx={{ height, width: "auto", display: "block", userSelect: "none", ...sx }}
      {...rest}
    />
  );
}

// The mark on its own, for tight spots where the wordmark would not fit.
// alt="" on purpose: it always appears beside the product name, so announcing
// it again would just make a screen reader say the brand twice.
export function Mark({ size = 28, sx = {}, ...rest }) {
  return (
    <Box
      component="img"
      src={`${base}/fennira-mark.png`}
      alt=""
      sx={{ height: size, width: "auto", display: "block", userSelect: "none", ...sx }}
      {...rest}
    />
  );
}
